import AppStoreBadges from "@/components/landing/AppStoreBadges";

interface Props {
  variant?: "default" | "compact";
  source?: string;
  className?: string;
}

const AppDownloadCTA = ({ variant = "default", source = "blog", className = "" }: Props) => {
  if (variant === "compact") {
    return (
      <AppStoreBadges
        size="sm"
        variant="dark"
        location={source}
        className={className}
      />
    );
  }

  return (
    <div
      className={`rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/5 to-primary/10 p-6 md:p-8 ${className}`}
    >
      <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">
        PieFolio AI
      </p>
      <p role="heading" aria-level={2} className="text-2xl md:text-3xl font-bold text-foreground mb-3">
        Track every position, dividend, and fee — in one app.
      </p>
      <p className="text-foreground/70 mb-6 max-w-prose">
        Free on iOS and Android. Add holdings across every broker, get an
        instant Portfolio Health score, and AI-written analysis of what you own.
      </p>
      <AppStoreBadges size="md" variant="dark" location={source} />
    </div>
  );
};

export default AppDownloadCTA;
